import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";
import Switch from "@material-ui/core/Switch";
import Button from "@material-ui/core/Button";
import colors, { colorsV2 } from "../../styles/colors";

import "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";

import CustomAppsService from "../../services/customapps";

class ProgramSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addedPrograms: [],
      assignedPrograms: props.assignedPrograms ? props.assignedPrograms : [],
      availablePrograms: props.availablePrograms ? props.availablePrograms : [],
      startDate: new Date(),
      endDate: null,
    };
    this.savePrograms = this.savePrograms.bind(this);
  }

  savePrograms() {
    CustomAppsService()
      .addProgramToCustomApp(
        this.props.customApp.appId,
        this.props.customApp.customAppId,
        this.state.addedPrograms,
        this.state.startDate,
        this.state.endDate
      )
      .then((resp) => {
        if (resp.msg === "ok") {
          this.props.onSave();
        } else {
          alert(
            "An error occured while trying to add the selected programs to the patient's care plan. Please try again. If problems persist please contact AC Health Support."
          );
        }
      });
  }

  render() {
    return (
      <div>
        {this.state.availablePrograms.map((p) => {
          return (
            <Paper
              key={p.programId}
              elevation={2}
              style={{ paddingLeft: 20, paddingRight: 20, marginBottom: 20 }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignContent: "center",
                  justifyContent: "space-between",
                }}
              >
                <p>{p.programName}</p>
                <Switch
                  color={colors.accent}
                  style={{ color: colors.accent }}
                  onChange={(event) => {
                    let updatedList = this.state.addedPrograms;
                    if (event.target.checked) {
                      const program = {
                        programId: p.programId,
                        programName: p.programName,
                      };
                      updatedList.push(program);
                    } else {
                      updatedList = updatedList.filter(
                        (item) => item.programId !== p.programId
                      );
                    }
                    this.setState({ addedPrograms: updatedList });
                  }}
                />
              </div>
            </Paper>
          );
        })}
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <KeyboardDatePicker
            disableToolbar
            variant="inline"
            format="MM/dd/yyyy"
            margin="normal"
            id="startDate-picker-inline"
            label="Program Start Date"
            value={this.state.startDate}
            onChange={(date) => {
              this.setState({ startDate: date });
            }}
          />
        </MuiPickersUtilsProvider>{" "}
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <KeyboardDatePicker
            disableToolbar
            variant="inline"
            format="MM/dd/yyyy"
            margin="normal"
            id="startDate-picker-inline"
            label="Program End Date"
            value={this.state.endDate}
            onChange={(date) => {
              this.setState({ endDate: date });
            }}
            minDate={this.state.startDate}
            minDateMessage={"End Date must be after Start Date"}
          />
        </MuiPickersUtilsProvider>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
            paddingTop: 30,
          }}
        >
          <Button
            onClick={() => {
              this.props.close();
            }}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              this.savePrograms();
            }}
            variant="outlined"
            style={{
              marginLeft: 20,
              backgroundColor: colors.orange,
              color: "white",
            }}
          >
            Save
          </Button>
        </div>
      </div>
    );
  }
}

export default ProgramSelector;



// WEBPACK FOOTER //
// ./src/components/common/ProgramSelector.js